<!-- POD component -->
<template>
  <div class="pod">
    <b-collapse aria-id="podHeader" :open="true">
      <div class="toggle-filter" slot="trigger" role="button" aria-controls="podHeader">
        <div class="pod-header">{{ pod.site.name }} - {{ pod.site.code }} </div> <!-- - order={{pod.order}}</div> -->
      </div>

      <div class="pod-days-container">
        <div class="pod-day" :class="{ 'is-day-actif' : isActif('0') }" @click="toggle('0')">{{$t('Pod.monday')}}</div>
        <div class="pod-day" :class="{ 'is-day-actif' : isActif('1') }" @click="toggle('1')">{{$t('Pod.tuesday')}}</div>
        <div class="pod-day" :class="{ 'is-day-actif' : isActif('2') }" @click="toggle('2')">{{$t('Pod.wednesday')}}</div>
        <div class="pod-day" :class="{ 'is-day-actif' : isActif('3') }" @click="toggle('3')">{{$t('Pod.thursday')}}</div>
        <div class="pod-day" :class="{ 'is-day-actif' : isActif('4') }" @click="toggle('4')">{{$t('Pod.friday')}}</div>
        <div class="pod-day" :class="{ 'is-day-actif' : isActif('5') }" @click="toggle('5')">{{$t('Pod.saturday')}}</div>
        <div class="pod-day" :class="{ 'is-day-actif' : isActif('6') }" @click="toggle('6')">{{$t('Pod.sunday')}}</div>
      </div>
    </b-collapse>
  </div>
</template>

<script>
export default {
  name: 'Pod',

  props: {
    planningId: { type: Number, required: true },
    podId: { type: Number },
    siteCode: { type: String },
    routeId: { type: Number }
  },

  computed: {
    pod: {
      get () {
        if (this.routeId != null) {
          return this.$store.getters['planning/routepod'](this.planningId)(this.routeId)(
            this.podId
          )
        } else {
          return this.$store.getters['planning/pod'](this.planningId)(this.siteCode)
        }
      },

      set (value) {
        if (this.routeId) {
          this.$store.dispatch('planning/updatePodRoutes', [this.planningId, this.route.id, value])
        }
      }
    }
  },

  methods: {
    isActif (day) {
      if (this.pod.days && this.pod.days.length === 7) {
        return this.pod.days[day]
      }
      return false
    },

    toggle (day) {
      if (this.pod.days.length === 7 && this.routeId != null) {
        // Is enable ?
        if (this.pod.days[day]) {
          if (this.checkDays(this.pod.days, day)) {
            // Set day to false
            this.pod.days[day] = false
            this.$store.dispatch('planning/updatePodRoutes', [this.planningId, this.routeId, this.pod])
            // Duplicate pod
            // Hack to copy object
            var copyPod = JSON.parse(JSON.stringify(this.pod))
            copyPod.days = [false, false, false, false, false, false, false]
            copyPod.days[day] = true
            // Add pod to main list
            this.$store.commit('planning/mergePodRoute', [this.planningId, copyPod])
          } else {
            // Add pod to main list
            this.$store.commit('planning/mergePodRoute', [this.planningId, this.pod])
            // Remove this pod to this route
            this.$store.dispatch('planning/deletePodRoutes', [this.planningId, this.routeId, this.podId])
          }
        }
      }
    },

    checkDays (days, day) {
      if (days) {
        for (let i = 0; i < days.length; i++) {
          if (i !== day) {
            if (this.pod.days[i]) {
              return true
            }
          }
        }
      }
    }
  }
}
</script>

<style lang="scss">
.pod {
  color: white;
  padding: 5px;
}

.pod-header {
  background-color: #448993;
  font-size: 1rem;
  color: white;
  //border-radius: 6px 6px 0 0;
  text-align: center;

  border-bottom-width: 2px;
  border-bottom-color: #ac936c;
  border-bottom-style: solid;
}

.pod-days-container {
  display: flex;
  background-color: #70aab3;
  //border-radius: 0px 0px 10px 10px;
}

.pod-day {
  flex: auto;
  text-align: center;
  margin: 5px;
  font-size: 0.75rem;
}

.is-day-actif {
  background-color: #ac936c;
  border-radius: 11px 11px 11px 11px;
}
</style>
